/// <amd-module name="Core/Medius.Core.Web/Scripts/components/sidebar/filters"/>
import * as React from "react";
import { GridCustomFilterCellProps } from "@progress/kendo-react-grid";
import {Input} from "@progress/kendo-react-inputs";
import {ConfigurableTypeDto} from "Core/Medius.Core.Web/Scripts/AdminPages/administrationServices";
import { HeaderThElement } from "@progress/kendo-react-data-tools";

export function DisplayNameFilter({value, onChange, thProps}: GridCustomFilterCellProps) {
    return (<HeaderThElement columnId={thProps?.columnId || ''} {...thProps}>
        <Input
            data-testid="display-name-filter"
            className="sidebar__grid__input"
            value={value || ""}
            onChange={({target}) => {
                onChange({
                    value: target.value ? target.value : "",
                    operator: target.value ? "contains" : "",
                    syntheticEvent: null as any // required by kendo API for on chage event, however not used here so null value
                });
            }}
            />
    </HeaderThElement>);
}

export function filterByDisplayName(types: ConfigurableTypeDto[], filterValue: string) {
    return types.filter(t => t.displayName.toLowerCase().includes(filterValue.toLowerCase()) || t.fullName.toLowerCase().includes(filterValue.toLowerCase()));
}
